"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindWestGale = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const WindWestGale = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "wind-west-gale", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "wind-west-gale", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ fill: "#334783", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "m21.025 23.056-1.583-1.653 5.3-5.542-5.347-5.59 1.582-1.653 6.928 7.243z" }), (0, jsx_runtime_1.jsx)("path", { d: "m15.454 12.824 5.118 2.762-6.88 7.196-1.584-1.654 5.3-5.542-5.346-5.59 1.582-1.653 6.928 7.243" }), (0, jsx_runtime_1.jsx)("path", { d: "m8.12 12.824 5.119 2.762-6.88 7.196-1.584-1.654 5.3-5.542-5.346-5.59L6.31 8.344l6.929 7.243" })] })) })) })));
};
exports.WindWestGale = WindWestGale;
